<section class="my-3">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-12">
                <app-slider></app-slider>
            </div>
            <div class="col-lg-4 col-12">
                <app-leader-message></app-leader-message>
            </div>
        </div>
    </div>
</section>

<section class="my-3 pt-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-12">
                <app-intro></app-intro>
            </div>
            <div class="col-lg-6 col-12">
                <app-notice-board></app-notice-board>
            </div>
        </div>
    </div>
</section>

<section class="my-3 pt-0">
    <div class="container">
        <app-footer-bar></app-footer-bar>
    </div>
</section>